// Global Types
import type {
  $Component,
} from 'common.types';

// Global Components
import * as React from 'react';

// Helpers
import {
  makeCode,
} from '@vroskus/library-helpers/dist/browser';

type $TextToLink = (input: string) => $Component<unknown>;

export const textToLink: $TextToLink = (input) => {
  let replacedText = input;

  const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;

  replacedText = input.replace(
    replacePattern1,
    '<a href="$1" target="_blank">$1</a>',
  );

  return (
    <span
      dangerouslySetInnerHTML={{
        __html: replacedText,
      }}
    />
  );
};

type $RichText = (input?: null | string) => Array<$Component<unknown>> | null;

export const richText: $RichText = (input) => {
  if (input) {
    const paragraphs: Array<string> = input.split('\n');

    return paragraphs.map((paragraph) => (
      <p key={makeCode(paragraph)}>
        {textToLink(paragraph)}
      </p>
    ));
  }

  return null;
};

type $Capitalize = (value: string) => string;

export const capitalize: $Capitalize = (value) => {
  if (value.length > 0) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  return value;
};
